function updateSlideScreenReaderText(splide, splideElement) {
    var screenReaderText = splideElement.querySelector('.live_region');
    var dataScreenreaderTextPostType =
        screenReaderText.getAttribute('data-label-showing');

    splide.on('moved', function (newIndex) {
        screenReaderText.textContent =
            dataScreenreaderTextPostType +
            ' ' +
            (newIndex + 1) +
            ' - ' +
            (newIndex + splide.options.perPage);
    });
}
